import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import { WorthHistory } from "@/types/ProfileWorth";

export interface PlayerWorthState {
  worthHistory: WorthHistory;
  isLoadingWorthHistory: boolean;
}

const initialState: PlayerWorthState = {
  worthHistory: {
    userWorth: [],
    familyWorth: [],
    gameWorth: [],
  },
  isLoadingWorthHistory: false,
};

export const getWorthHistory = createAsyncThunk(
  "playerWorth/getWorthHistory",
  async ({ name }: { name: string }) => {
    const response = await axios.get(`${SERVER_URL}/profile/worthHistory/${name}`);
    return response.data as WorthHistory;
  }
);

const playerWorthSlice = createSlice({
  name: "playerWorth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorthHistory.pending, (state) => {
      state.isLoadingWorthHistory = true;
    });
    builder.addCase(getWorthHistory.fulfilled, (state, { payload }) => {
      state.worthHistory = payload;
      state.isLoadingWorthHistory = false;
    });
    builder.addCase(getWorthHistory.rejected, (state) => {
      state.isLoadingWorthHistory = false;
    });
  },
});

export default playerWorthSlice.reducer;
